import CustomModal from '../../components/Modal/Modal';
import '../../screens/Modals/delete-conformation-modal/delete-conformation-modal.scss';

interface LogoutModalI {
  open: boolean;
  handleCancel: () => void;
  handleLogoutClick: () => void;
}

const LogoutModal = ({ open, handleCancel, handleLogoutClick }: LogoutModalI) => {
  return (
    <CustomModal open={open} handleClose={handleCancel}>
      <div className='modal-container'>
      <div>
        <p>Are you sure want to Logout?</p>
      </div>
      <div className='buttonContainer'>
        <button className='cancelButton' onClick={handleCancel}>Cancel</button>
        <button className='saveButton' onClick={handleLogoutClick} >Logout</button>
      </div>
    </div>
    </CustomModal>
  );
};

export default LogoutModal;
